import { SimpleChanges, Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, OnChanges, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../store/application-store';
import { WidgetComponent } from '../../dashboards/components/widget-component/widget-component';
import { ContactUsModel } from '../models/contactus-model';
import { UrlBuilderService } from '../../common/services/url-builder.service';
import { ContactUsHttpService } from '../services/contactus-http.service';
import { ConfirmationService } from 'primeng/api';
import { takeWhile } from 'rxjs';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'mojo-contactus-widget',
  templateUrl: './contactus-widget.component.html'
})

export class ContactUsWidgetComponent extends WidgetComponent implements OnInit, OnChanges, OnDestroy {

  @Input() loading: boolean;
  @Input() contactInfo: ContactUsModel[];
  isAlive: boolean = true;

  currentContact: ContactUsModel;
  loadingProfileImage: boolean = true;
  profileImageExists: boolean = true;

  displayOverlay: boolean = false;
  fadeOut: boolean = false;

  private currentContactIndex: number;

  constructor(
    protected store: Store<ApplicationState>,
    private changeDetector: ChangeDetectorRef,
    private urlBuilder: UrlBuilderService,
    private contactUsHttpService: ContactUsHttpService,
    protected confirmationService: ConfirmationService) {
    super(store, confirmationService);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['contactInfo']) {
      this.initialiseCurrentContact();
    }
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

  mouseEnterImage(event: any): void {
    this.displayOverlay = true;
  }
  mouseLeaveOverlayOrImage(event: any): void {
    this.displayOverlay = false;
  }

  imageUrl(): string {
    return this.urlBuilder.getUrl('managers/image?code=' + this.currentContact.ManagerCode);
  }

  showPhoneNumber(): boolean {
    if (!this.currentContact)
    if (!this.currentContact)
      return false;
    return this.isFalseyOrWhiteSpace(this.currentContact.ManagerMobilePhone) &&
      this.isFalseyOrWhiteSpace(this.currentContact.ManagerDirectPhone);
  }

  hasMultipleContacts(): boolean {
    return Array.isArray(this.contactInfo) && this.contactInfo.length > 1;
  }

  hasContactInfo(): boolean {
    return Array.isArray(this.contactInfo);
  }

  nextContact(): void {
    this.fadeOut = true;
    setTimeout(() => {
      this.currentContactIndex = this.currentContactIndex + 1;
      this.currentContactIndex = this.currentContactIndex % this.contactInfo.length;
      this.currentContact = this.contactInfo[this.currentContactIndex];
      this.fadeOut = false;
      this.loadProfileImage();
      this.changeDetector.detectChanges();
    }, 250);
  }

  prevContact(): void {
    this.fadeOut = true;

    setTimeout(() => {
      if (this.currentContactIndex === 0) {
        this.currentContactIndex = this.contactInfo.length;
      }
      this.currentContactIndex = this.currentContactIndex - 1;
      this.currentContact = this.contactInfo[this.currentContactIndex];
      this.fadeOut = false;
      this.loadProfileImage();
      this.changeDetector.detectChanges();
    }, 250);
  }

  loadProfileImage() {
    this.loadingProfileImage = true;
    if (this.currentContact) {
      this.contactUsHttpService.imageExists(this.currentContact.ManagerCode).pipe(
        takeWhile(() => this.isAlive)
      ).subscribe(val => {
        this.profileImageExists = val;
        this.loadingProfileImage = false;
        this.changeDetector.detectChanges();
      });
    }
  }

  private isFalseyOrWhiteSpace(text: string): boolean {
    if (typeof text === 'undefined' || text == null) return true;
    return text.replace(/\s/g, '').length < 1;
  }

  private initialiseCurrentContact() {
    if (this.hasContactInfo()) {
      this.currentContactIndex = 0;
      this.currentContact = this.contactInfo[this.currentContactIndex];
      this.loadProfileImage();
    }
  }
}
